import * as n from "react";
import { useState as C } from "react";
import { g as R } from "./mutation-De-1gXxl.js";
import { S as O, s as k, h, n as f, g as I, i as E, k as M } from "./ZudokuContext-BcqSiygJ.js";
import { j as s } from "./jsx-runtime-DywqP_6a.js";
import { c as z } from "./index-DI5SPFK9.js";
import { c as o } from "./cn-dYga0KKN.js";
import { EyeOffIcon as T, EyeIcon as B, CheckIcon as U, CopyIcon as D, ChevronDown as x, ChevronUp as A, Check as K } from "lucide-react";
import { u as L } from "./useCopyToClipboard-B_085nfO.js";
import { Button as p } from "./ui/Button.js";
import * as i from "@radix-ui/react-select";
var V = class extends O {
  #s;
  #a = void 0;
  #t;
  #e;
  constructor(t, e) {
    super(), this.#s = t, this.setOptions(e), this.bindMethods(), this.#r();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    const e = this.options;
    this.options = this.#s.defaultMutationOptions(t), k(this.options, e) || this.#s.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.#t,
      observer: this
    }), e?.mutationKey && this.options.mutationKey && h(e.mutationKey) !== h(this.options.mutationKey) ? this.reset() : this.#t?.state.status === "pending" && this.#t.setOptions(this.options);
  }
  onUnsubscribe() {
    this.hasListeners() || this.#t?.removeObserver(this);
  }
  onMutationUpdate(t) {
    this.#r(), this.#i(t);
  }
  getCurrentResult() {
    return this.#a;
  }
  reset() {
    this.#t?.removeObserver(this), this.#t = void 0, this.#r(), this.#i();
  }
  mutate(t, e) {
    return this.#e = e, this.#t?.removeObserver(this), this.#t = this.#s.getMutationCache().build(this.#s, this.options), this.#t.addObserver(this), this.#t.execute(t);
  }
  #r() {
    const t = this.#t?.state ?? R();
    this.#a = {
      ...t,
      isPending: t.status === "pending",
      isSuccess: t.status === "success",
      isError: t.status === "error",
      isIdle: t.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #i(t) {
    f.batch(() => {
      if (this.#e && this.hasListeners()) {
        const e = this.#a.variables, a = this.#a.context;
        t?.type === "success" ? (this.#e.onSuccess?.(t.data, e, a), this.#e.onSettled?.(t.data, null, e, a)) : t?.type === "error" && (this.#e.onError?.(t.error, e, a), this.#e.onSettled?.(
          void 0,
          t.error,
          e,
          a
        ));
      }
      this.listeners.forEach((e) => {
        e(this.#a);
      });
    });
  }
};
function at(t, e) {
  const a = I(e), [r] = n.useState(
    () => new V(
      a,
      t
    )
  );
  n.useEffect(() => {
    r.setOptions(t);
  }, [r, t]);
  const l = n.useSyncExternalStore(
    n.useCallback(
      (d) => r.subscribe(f.batchCalls(d)),
      [r]
    ),
    () => r.getCurrentResult(),
    () => r.getCurrentResult()
  ), c = n.useCallback(
    (d, u) => {
      r.mutate(d, u).catch(E);
    },
    [r]
  );
  if (l.error && M(r.options.throwOnError, [l.error]))
    throw l.error;
  return { ...l, mutate: c, mutateAsync: l.mutate };
}
const P = z(
  "relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive: "text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function rt({
  className: t,
  variant: e,
  ...a
}) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: o(P({ variant: e }), t),
      ...a
    }
  );
}
function it({ className: t, ...e }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "alert-title",
      className: o(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        t
      ),
      ...e
    }
  );
}
function ot({
  className: t,
  ...e
}) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "alert-description",
      className: o(
        "text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed",
        t
      ),
      ...e
    }
  );
}
const _ = ({
  secret: t,
  revealed: e = !1,
  previewChars: a = 5,
  className: r
}) => /* @__PURE__ */ s.jsxs("span", { className: o("w-full truncate", r), children: [
  /* @__PURE__ */ s.jsx(
    "div",
    {
      className: o(
        "w-40 inline-block md:w-fit",
        e ? "" : "opacity-50"
      ),
      children: e ? t.slice(0, a === 0 ? t.length : -a) : "•••• ".repeat(
        t.slice(
          0,
          a === 0 ? t.length : -a
        ).length / 5
      ) + "•".repeat(
        t.slice(
          0,
          a === 0 ? t.length : -a
        ).length % 5
      )
    }
  ),
  a > 0 && /* @__PURE__ */ s.jsx("span", { children: t.slice(-a) })
] }), nt = ({
  secret: t,
  preview: e = 5,
  className: a,
  status: r,
  onCopy: l,
  revealed: c,
  onReveal: d,
  noReveal: u
}) => {
  const y = Math.abs(e), [v, j] = C(!1), [N, S] = L(), m = c ?? v;
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: o(
        "flex gap-2 items-center text-sm border rounded-md px-1",
        a
      ),
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "font-mono w-full h-9 items-center flex px-2 text-xs gap-2", children: [
          r && /* @__PURE__ */ s.jsx(
            "div",
            {
              className: o(
                "rounded-full shrink-0 w-2 h-2 mr-2",
                r === "active" && "bg-emerald-400",
                r === "expired" && "bg-neutral-200",
                r === "expiring" && "bg-yellow-400",
                r === "revoked" && "bg-red-400",
                r === "none" && "opacity-0"
              )
            }
          ),
          /* @__PURE__ */ s.jsx(
            _,
            {
              secret: t,
              revealed: m,
              previewChars: y
            }
          )
        ] }),
        u !== !0 && /* @__PURE__ */ s.jsx(
          p,
          {
            variant: "ghost",
            onClick: () => {
              j((w) => !w), d?.(!m);
            },
            size: "icon",
            children: m ? /* @__PURE__ */ s.jsx(T, { size: 16 }) : /* @__PURE__ */ s.jsx(B, { size: 16 })
          }
        ),
        /* @__PURE__ */ s.jsx(
          p,
          {
            variant: "ghost",
            onClick: () => {
              S(t), l?.(t);
            },
            size: "icon",
            children: N ? /* @__PURE__ */ s.jsx(U, { size: 16 }) : /* @__PURE__ */ s.jsx(D, { size: 16 })
          }
        )
      ]
    }
  );
}, lt = i.Root, dt = i.Group, ct = i.Value, G = n.forwardRef(({ className: t, children: e, ...a }, r) => /* @__PURE__ */ s.jsxs(
  i.Trigger,
  {
    ref: r,
    className: o(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-1 focus:ring-ring focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
      t
    ),
    ...a,
    children: [
      /* @__PURE__ */ s.jsx("span", { className: "truncate", children: e }),
      /* @__PURE__ */ s.jsx(i.Icon, { asChild: !0, children: /* @__PURE__ */ s.jsx(x, { className: "shrink-0 h-4 w-4 opacity-50" }) })
    ]
  }
));
G.displayName = i.Trigger.displayName;
const g = n.forwardRef(({ className: t, ...e }, a) => /* @__PURE__ */ s.jsx(
  i.ScrollUpButton,
  {
    ref: a,
    className: o(
      "flex cursor-default items-center justify-center py-1",
      t
    ),
    ...e,
    children: /* @__PURE__ */ s.jsx(A, { className: "h-4 w-4" })
  }
));
g.displayName = i.ScrollUpButton.displayName;
const b = n.forwardRef(({ className: t, ...e }, a) => /* @__PURE__ */ s.jsx(
  i.ScrollDownButton,
  {
    ref: a,
    className: o(
      "flex cursor-default items-center justify-center py-1",
      t
    ),
    ...e,
    children: /* @__PURE__ */ s.jsx(x, { className: "h-4 w-4" })
  }
));
b.displayName = i.ScrollDownButton.displayName;
const q = n.forwardRef(({ className: t, children: e, position: a = "popper", ...r }, l) => /* @__PURE__ */ s.jsx(i.Portal, { children: /* @__PURE__ */ s.jsxs(
  i.Content,
  {
    ref: l,
    className: o(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      a === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      t
    ),
    position: a,
    ...r,
    children: [
      /* @__PURE__ */ s.jsx(g, {}),
      /* @__PURE__ */ s.jsx(
        i.Viewport,
        {
          className: o(
            a === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]",
            "divide-y"
          ),
          children: e
        }
      ),
      /* @__PURE__ */ s.jsx(b, {})
    ]
  }
) }));
q.displayName = i.Content.displayName;
const Q = n.forwardRef(({ className: t, ...e }, a) => /* @__PURE__ */ s.jsx(
  i.Label,
  {
    ref: a,
    className: o("py-1.5 pl-8 pr-2 text-sm font-semibold", t),
    ...e
  }
));
Q.displayName = i.Label.displayName;
const F = n.forwardRef(({ className: t, children: e, ...a }, r) => /* @__PURE__ */ s.jsxs(
  i.Item,
  {
    ref: r,
    className: o(
      "relative flex w-full cursor-default select-none items-center py-1.5 pl-8 pr-2 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...a,
    children: [
      /* @__PURE__ */ s.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ s.jsx(i.ItemIndicator, { children: /* @__PURE__ */ s.jsx(K, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ s.jsx(i.ItemText, { children: e })
    ]
  }
));
F.displayName = i.Item.displayName;
const H = n.forwardRef(({ className: t, ...e }, a) => /* @__PURE__ */ s.jsx(
  i.Separator,
  {
    ref: a,
    className: o("-mx-1 my-1 h-px bg-muted", t),
    ...e
  }
));
H.displayName = i.Separator.displayName;
export {
  rt as A,
  lt as S,
  it as a,
  ot as b,
  G as c,
  ct as d,
  q as e,
  dt as f,
  F as g,
  nt as h,
  _ as i,
  at as u
};
//# sourceMappingURL=Select-CegS9OKH.js.map
